'use client'

import { Input } from '@/components/input/input'
import { noOp } from '@/utils/functions/noOp'
import { cn } from '@/utils/styles/cn'

interface IBecomeAPartnerSearchPlaceholderProps {
    onOpen: () => void
    label?: string
    placeholder?: string
}

export const BecomeAPartnerSearchPlaceholder = ({
    onOpen,
    label,
    placeholder,
}: IBecomeAPartnerSearchPlaceholderProps) => (
    <div className={cn('relative w-full md:w-auto flex')}>
        <div className="flex gap-1 items-center w-full overflow-hidden">
            <Input
                autoComplete="new-password"
                label={label}
                value=""
                onValueChange={noOp}
                placeholder={placeholder}
                inputClassName="min-h-[54px] border-[2px] truncate border-none"
                containerClassName="w-full"
                onClick={onOpen}
            />
        </div>
    </div>
)
